import { withNestedConverter } from './utils';
import { WhatsappBotCartDraft } from './whatsappBot.types';

export const getWhatsappBotCartDraftConverter = withNestedConverter<WhatsappBotCartDraft>({
  fromFirestore(snapshot) {
    return <WhatsappBotCartDraft>snapshot.data();
  },
  toFirestore(modelObject: WhatsappBotCartDraft): WhatsappBotCartDraft {
    return modelObject;
  },
});
